<template>
  <div id="user-app" class="border border-solid d-theme-border-grey-light rounded relative overflow-hidden body-module-height z-20">
    <div class="vx-row hidden md:flex items-center mb-2 h-12">
      <div class="vx-col w-1/2 md:w-1/12 text-left"> Avatar </div>
      <div class="vx-col w-1/2 md:w-1/6 flex justify-center"> Nome </div>
      <div class="vx-col w-1/2 md:w-1/6 flex justify-center"> Email </div>
      <div class="vx-col w-1/2 md:w-1/6 flex justify-center"> Nick </div>
      <div class="vx-col w-1/2 md:w-1/6 flex justify-center"> Role </div>
    </div>

    <bds-scroll-area component-class="content-scroll-area specific-height" v-if="loaded">
      <transition-group name="list-enter-up" class="email__mails" tag="ul" appear>
        <li class="cursor-pointer email__mail-item" v-for="(value, key, index) in users" :key="key"
            :style="{transitionDelay: (index * 0.1) + 's'}">
          <user-list-item :user-param="value" :editButtons="false"/>
        </li>
      </transition-group>
    </bds-scroll-area>
  </div>
</template>

<script>
import UserListItem from "@/views/users/UserListItem";
import UserService from '@/services/User.service';
import {User} from "@/models/User.model";
import {showErrorNotify} from "@/helpers/functionsHelpers";

export default {
  name: "students",
  components: {
    UserListItem
  },
  data() {
    return {
      invitedUsers: [],
      loaded: false,
    }
  },
  computed: {
    users() {
      return this.invitedUsers;
    }
  },
  methods: {

  },
  mounted() {
    this.invitedUsers = [];
    UserService.getInvitedUsers().then((response) => {
      for (let u of response) {
        let user = User.FromObj(u);
        this.invitedUsers.push(user);
      }
      this.loaded = true;
    }, (error) => {
      showErrorNotify(this, error);
    });
  }
}
</script>

<style>

</style>
